/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {getBillList,getBillListForDealer} from "@/api/Bill"

export default {
  addBill({ commit }, bill) {
    return new Promise((resolve, reject) => {
      commit('ADD_BILL', bill)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  updateBill({ commit }, bill) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_BILL', bill)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeBill({commit},id){
    return new Promise((resolve,reject) => {
      commit("REMOVE_BILL",id)
        resolve()
        .catch((error) => {reject(error)})
    });
  },
  fetchDataListItemsBill({ commit },payload) {
    return new Promise((resolve, reject) => {
      getBillList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_BILLS', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }

      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  fetchDataListItemsBillForDealer({ commit },payload) {
    return new Promise((resolve, reject) => {
      getBillListForDealer(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_BILLS', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }

      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  }
};
